module.exports = __webpack_public_path__ + "static/kasey-resume-2021-edit-77a57f41e33e6edd9bc70d771717d738.pdf";